export const obtenerHora = (fecha) => {

    let hora = new Date(fecha).getHours()

    if (hora > 12) {
        return hora - 12 + ' pm'
    } else {
        return hora + ' am'
    }

}